import script from "./knowledge-list.vue?vue&type=script&setup=true&lang=js"
export * from "./knowledge-list.vue?vue&type=script&setup=true&lang=js"

import "./knowledge-list.vue?vue&type=style&index=0&id=aec0e1c4&scoped=true&lang=scss"

import exportComponent from "E:\\web-project\\chun-qiu-museum\\node_modules\\_vue-loader@17.0.0@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aec0e1c4"]])

export default __exports__